// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* The device with borders */
.smartphone {
    position: relative;
    width: 360px;
    height: 640px;
    margin: auto;
    border: 16px black solid;
    border-top-width: 60px;
    border-bottom-width: 60px;
    border-radius: 36px;
  }
  
  /* The horizontal line on the top of the device */
  .smartphone:before {
    content: '';
    display: block;
    width: 60px;
    height: 5px;
    position: absolute;
    top: -30px;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #6b7280;
    border-radius: 10px;
  }
  
  /* The circle on the bottom of the device */
  .smartphone:after {
    content: '';
    display: block;
    width: 35px;
    height: 35px;
    position: absolute;
    left: 50%;
    bottom: -65px;
    transform: translate(-50%, -50%);
    background: #333;
    border-radius: 50%;
  }
  
  /* The screen (or content) of the device */
  .smartphone .content {
    width: 327px;
    height: 520px;
    background: #6b7280;
  }

#myFrame{
    border: 0;
height: 100%;
width: 100%;
}

#buttonHolder{
  padding-left: 52%;
  padding-top: 2%;
}

#myList {
  list-style-type: none;
}

.list-group-light {
  --mdb-list-group-light-item-py: 1rem;
  padding-left: 4px;
  margin-top: 10px;
  width: 100%;
  /* --mdb-list-group-light-item-border: 2px solid whitesmoke; */
  /* --mdb-list-group-light-item-border-width: 2px; */
  /* --mdb-list-group-light-active-border-radius: 0.5rem; */
  /* --mdb-list-group-light-active-bg: #dfe7f6; */
  /* --mdb-list-group-light-active-color: #2c58a0; */
}

/* #elItem{
  padding-left: 4px;
  width: 100%;
} */

.image__overlay{
position: absolute;
top: 0;
left: 0;
width: 100%;
height: 100%;
background: rgba(0, 0, 0, 0.6);
color: #ffffff;
font-family: 'Quicksand',sans-serif;
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
opacity: 0;
transition: opacity 0.25s;
}

.image__overlay:hover{
  opacity: 1;
}


#secondDiv{
  margin-left: 2.5%;
}

@media (max-width: 1440px) {
	.custom-svg-w{
    width: 100%;
    padding-right: 15%;
    margin-right: 20%;
    
  }

  .custom-size{
    height: 560px;
    width: 265px;
  }
  #headingDiv{
		width: 95%;
		height: 70px;
		
	}
  #secondDiv{
		width: 95%;
		height: 100%;
    padding-left: 0%;
	}
  #screen{
    height: 529px;
    width: 237px;
  }
  #buttonHolder{
    margin-right: 42px;
  }
  .text-custom{
    font-size: 1.4rem;
		line-height: 2rem;
  }

}`, "",{"version":3,"sources":["webpack://./src/css/CreationMessage.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,wBAAwB;IACxB,sBAAsB;IACtB,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA,iDAAiD;EACjD;IACE,WAAW;IACX,cAAc;IACd,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,gCAAgC;IAChC,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA,2CAA2C;EAC3C;IACE,WAAW;IACX,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,aAAa;IACb,gCAAgC;IAChC,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA,0CAA0C;EAC1C;IACE,YAAY;IACZ,aAAa;IACb,mBAAmB;EACrB;;AAEF;IACI,SAAS;AACb,YAAY;AACZ,WAAW;AACX;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,8DAA8D;EAC9D,mDAAmD;EACnD,yDAAyD;EACzD,+CAA+C;EAC/C,kDAAkD;AACpD;;AAEA;;;GAGG;;AAEH;AACA,kBAAkB;AAClB,MAAM;AACN,OAAO;AACP,WAAW;AACX,YAAY;AACZ,8BAA8B;AAC9B,cAAc;AACd,mCAAmC;AACnC,aAAa;AACb,sBAAsB;AACtB,mBAAmB;AACnB,uBAAuB;AACvB,UAAU;AACV,yBAAyB;AACzB;;AAEA;EACE,UAAU;AACZ;;;AAGA;EACE,iBAAiB;AACnB;;AAEA;CACC;IACG,WAAW;IACX,kBAAkB;IAClB,iBAAiB;;EAEnB;;EAEA;IACE,aAAa;IACb,YAAY;EACd;EACA;EACA,UAAU;EACV,YAAY;;CAEb;EACC;EACA,UAAU;EACV,YAAY;IACV,gBAAgB;CACnB;EACC;IACE,aAAa;IACb,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB,iBAAiB;EACjB;;AAEF","sourcesContent":["/* The device with borders */\n.smartphone {\n    position: relative;\n    width: 360px;\n    height: 640px;\n    margin: auto;\n    border: 16px black solid;\n    border-top-width: 60px;\n    border-bottom-width: 60px;\n    border-radius: 36px;\n  }\n  \n  /* The horizontal line on the top of the device */\n  .smartphone:before {\n    content: '';\n    display: block;\n    width: 60px;\n    height: 5px;\n    position: absolute;\n    top: -30px;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    background: #6b7280;\n    border-radius: 10px;\n  }\n  \n  /* The circle on the bottom of the device */\n  .smartphone:after {\n    content: '';\n    display: block;\n    width: 35px;\n    height: 35px;\n    position: absolute;\n    left: 50%;\n    bottom: -65px;\n    transform: translate(-50%, -50%);\n    background: #333;\n    border-radius: 50%;\n  }\n  \n  /* The screen (or content) of the device */\n  .smartphone .content {\n    width: 327px;\n    height: 520px;\n    background: #6b7280;\n  }\n\n#myFrame{\n    border: 0;\nheight: 100%;\nwidth: 100%;\n}\n\n#buttonHolder{\n  padding-left: 52%;\n  padding-top: 2%;\n}\n\n#myList {\n  list-style-type: none;\n}\n\n.list-group-light {\n  --mdb-list-group-light-item-py: 1rem;\n  padding-left: 4px;\n  margin-top: 10px;\n  width: 100%;\n  /* --mdb-list-group-light-item-border: 2px solid whitesmoke; */\n  /* --mdb-list-group-light-item-border-width: 2px; */\n  /* --mdb-list-group-light-active-border-radius: 0.5rem; */\n  /* --mdb-list-group-light-active-bg: #dfe7f6; */\n  /* --mdb-list-group-light-active-color: #2c58a0; */\n}\n\n/* #elItem{\n  padding-left: 4px;\n  width: 100%;\n} */\n\n.image__overlay{\nposition: absolute;\ntop: 0;\nleft: 0;\nwidth: 100%;\nheight: 100%;\nbackground: rgba(0, 0, 0, 0.6);\ncolor: #ffffff;\nfont-family: 'Quicksand',sans-serif;\ndisplay: flex;\nflex-direction: column;\nalign-items: center;\njustify-content: center;\nopacity: 0;\ntransition: opacity 0.25s;\n}\n\n.image__overlay:hover{\n  opacity: 1;\n}\n\n\n#secondDiv{\n  margin-left: 2.5%;\n}\n\n@media (max-width: 1440px) {\n\t.custom-svg-w{\n    width: 100%;\n    padding-right: 15%;\n    margin-right: 20%;\n    \n  }\n\n  .custom-size{\n    height: 560px;\n    width: 265px;\n  }\n  #headingDiv{\n\t\twidth: 95%;\n\t\theight: 70px;\n\t\t\n\t}\n  #secondDiv{\n\t\twidth: 95%;\n\t\theight: 100%;\n    padding-left: 0%;\n\t}\n  #screen{\n    height: 529px;\n    width: 237px;\n  }\n  #buttonHolder{\n    margin-right: 42px;\n  }\n  .text-custom{\n    font-size: 1.4rem;\n\t\tline-height: 2rem;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
